export const MainPages = {
  Home: "/",
  Edit: "/edit",
  Verify: "/verifyemail",
  VerifyOld: "/verify-email",
  TopDestination: "/chat",
  Personalis: "/personalize",
  ItineraryDetails: "/itinerary",
  SavedItineraryList: "/saveditinerarylist",
  RecentSearch: "/recentsearch",
  EditAccount: "/editaccount",
  Account: "/account",
  ResetPassword: "/resetpassword",
  SavedItineraryDetails: "/saveditinerarydetails",
  Landing: "/landing",
  RecommendedTrips: "/recommendedtrips",
  Testpage: "/testpage",
  AdjustTrip: "/adjustTrip",
  PreviewPreference: "/previewpreference",
  ReOrder: "/reorder",
  ReorderMultiCityTrip: "/reordermulticitytrip",
  DesktopLandingPage: "/desktoplandingpage",
  SingleItineraryDetails: "/singleitinerarydetails",
  NewTrip: "/newtrip",
  Faqs: "/faqs",
  Tos: "/tos",
  PrivacyPolicy: "/privacypolicy",
  Booking: "/bookingold",
  ModifyHotelReservation: "/modifyhotelreservation",
  HotelDetails: "/hoteldetails",
  TravelerInformation: "/travelerinformation",
  weatherAdvisory: "/weatheradvisory",
  FlightDelay: "/flightdelay",
  FlightSelect: "/flightselect",
  ExploreCity: "/explorecity",
  FaqAssistance: "/assistant",
  MyTrips: "/mytrips",
  TripDetails: "/trip",
  // lares alert-resolution deep-link target (SMS). Public route, path param.
  TripById: "/trips/:itineraryId",
  TripDetailsOld: "/trip-details",
  Today: "/today",
  RecommendedTripDetails: "recommendedtrip",
  AboutUs: "aboutus",
  PaymentSuccess: "/paymentsuccess",
  PaymentFailure: "/paymentfailure",
  ForYou: "/foryou",
  ModifyFlights: "/modifyFlights",
  ModifyHotelsSuccess: "/modifyhotelssuccess",
  BookingInProgress: "/booking",
  SavedTrip: "/savedtrip",
  BookingLoader: "/bookingloader",
  TripHelp: "/triphelp",
  History: "/history",
  preferences: "/preferences",
  onBoarding: "/onboarding",
  TicketDetails: "/ticket",
  Login: "/login",
};

export const ROUTES = {
  ...MainPages,
};

export const PUBLIC_ROUTES = [];

export const PROTECTED_ROUTES = [];
